import { convertSearchQueryId } from './converterHelpers';
import convertSearchResultConversationToConversationType from './convertSearchResultConversationToConversationType';
import convertSearchResultEventToCalendarItemType from './convertSearchResultEventToCalendarItemType';
import convertSearchResultMessageToMessageType from './convertSearchResultMessageToMessageType';
import createEmptySearchResponse from './createEmptySearchResponse';
import getSearchResultSet from './getSearchResultSet';
import SubstrateSearchRequest from '../../../data/schema/SubstrateSearchRequest';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import ConversationType from 'owa-service/lib/contract/ConversationType';
import ExecuteSearchResponseMessage from 'owa-service/lib/contract/ExecuteSearchResponseMessage';
import Message from 'owa-service/lib/contract/Message';
import SubstrateSearchResponse, {
    SearchResultConversation,
    SearchResultEvent,
    SearchResultMessage,
} from '../../../data/schema/SubstrateSearchResponse';

/**
 * This function converts the 3S response body to the ExecuteSearch response format.
 */
export default function substrateResponseBodyToExecuteSearchResponseBody(
    responseBody: SubstrateSearchResponse,
    request: SubstrateSearchRequest
): ExecuteSearchResponseMessage {
    const resultSet = getSearchResultSet(responseBody);

    /**
     * If result set didn't get returned or if result set is empty return an
     * empty search result set.
     */
    if (!resultSet || !resultSet.Results || resultSet.Results.length === 0) {
        return createEmptySearchResponse();
    }

    const searchResults = resultSet.Results;
    const searchResultsCount = searchResults.length;
    const messageList: Message[] = [];
    const conversationList: ConversationType[] = [];
    const calendarItemList: CalendarItem[] = [];

    switch (responseBody.EntitySets[0].Type) {
        case 'Message':
        case 'Messages':
            for (const searchResult of searchResults) {
                const messageType = convertSearchResultMessageToMessageType(
                    searchResult.Source as SearchResultMessage,
                    request
                );
                messageType.InstanceKey = searchResult.ReferenceId;
                messageList.push(messageType);
            }
            break;
        case 'Conversation':
        case 'Conversations':
            for (const searchResult of searchResults) {
                const conversationType = convertSearchResultConversationToConversationType(
                    searchResult.Source as SearchResultConversation,
                    request
                );
                conversationType.InstanceKey = searchResult.ReferenceId;
                conversationList.push(conversationType);
            }
            break;
        case 'Event':
        case 'Events':
            for (const searchResult of searchResults) {
                const eventType = convertSearchResultEventToCalendarItemType(
                    searchResult.Source as SearchResultEvent
                );
                eventType.InstanceKey = searchResult.ReferenceId;
                calendarItemList.push(eventType);
            }
            break;
        default:
            break;
    }

    return {
        SearchResults: {
            Items: messageList.length > 0 ? messageList : null,
            Conversations: conversationList.length > 0 ? conversationList : null,
            CalendarItems: calendarItemList.length > 0 ? calendarItemList : null,
            MoreResultsAvailable: resultSet.MoreResultsAvailable,
            SearchRefiners: null,
            TotalResultsCount: resultSet.Total,
            SearchTerms: responseBody.SearchTerms,
            SearchResultsCount: searchResultsCount,
            TDQueryId: convertSearchQueryId(resultSet),
        },
    };
}
